import { render, staticRenderFns } from "./wsSidebarScripts.vue?vue&type=template&id=4538a55a&scoped=true&"
import script from "./wsSidebarScripts.vue?vue&type=script&lang=js&"
export * from "./wsSidebarScripts.vue?vue&type=script&lang=js&"
import style0 from "./wsSidebarScripts.vue?vue&type=style&index=0&id=4538a55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538a55a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VHover,VSheet})
